module.exports = __webpack_public_path__ + "img/logo-dark.be6c0f15.svg";